(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react'), require('crypto'), require('immutable'), require('emotion'), require('react-dom'), require('react-virtualized'), require('react-popper'), require('debounce')) :
  typeof define === 'function' && define.amd ? define(['exports', 'react', 'crypto', 'immutable', 'emotion', 'react-dom', 'react-virtualized', 'react-popper', 'debounce'], factory) :
  (factory((global.FunctionalDataGrid = {}),global.React,global.crypto,global.immutable,global.emotion,global.ReactDOM,global.reactVirtualized,global.reactPopper,global.debounce));
}(this, (function (exports,React,crypto,immutable,emotion,ReactDOM,reactVirtualized,reactPopper,debounce) { 'use strict';

  var React__default = 'default' in React ? React['default'] : React;
  crypto = crypto && crypto.hasOwnProperty('default') ? crypto['default'] : crypto;
  ReactDOM = ReactDOM && ReactDOM.hasOwnProperty('default') ? ReactDOM['default'] : ReactDOM;
  debounce = debounce && debounce.hasOwnProperty('default') ? debounce['default'] : debounce;

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};

    var target = _objectWithoutPropertiesLoose(source, excluded);

    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
      raw = strings.slice(0);
    }

    return Object.freeze(Object.defineProperties(strings, {
      raw: {
        value: Object.freeze(raw)
      }
    }));
  }

  var TextBoxFilter =
  /*#__PURE__*/
  function (_React$PureComponent) {
    _inherits(TextBoxFilter, _React$PureComponent);

    function TextBoxFilter(props) {
      var _this;

      _classCallCheck(this, TextBoxFilter);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(TextBoxFilter).call(this, props));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "render", function () {
        return React__default.createElement("input", {
          type: "text",
          style: {
            width: '100%',
            boxSizing: 'border-box',
            padding: '2px 5px',
            backgroundColor: '#eee',
            border: 'solid 1px #ccc',
            color: '#000'
          },
          onChange: _this.triggerOnUpdateFilter
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "triggerOnUpdateFilter", function (event) {
        event.persist();

        _this.props.onUpdateFilter(function (value) {
          return (value == null ? '' : value.toString()).toUpperCase().includes(event.target.value.toUpperCase());
        });
      });

      return _this;
    }

    return TextBoxFilter;
  }(React__default.PureComponent);

  var Column = // eslint-disable-line
  // eslint-disable-line
  function Column(options) {
    _classCallCheck(this, Column);

    _defineProperty(this, "defaultComparator", function (a, b) {
      if (a == null) {
        if (b == null) return 0;else return 1;
      } else if (b == null) return -1;else {
        if (a === b) return 0;else if (a < b) return -1;else return 1;
      }
    });

    _defineProperty(this, "id", void 0);

    _defineProperty(this, "title", '');

    _defineProperty(this, "valueGetter", void 0);

    _defineProperty(this, "filterable", false);

    _defineProperty(this, "sortable", false);

    _defineProperty(this, "resizable", true);

    _defineProperty(this, "hidden", false);

    _defineProperty(this, "renderer", function (v) {
      return v;
    });

    _defineProperty(this, "aggregateRenderer", void 0);

    _defineProperty(this, "aggregateValueGetter", void 0);

    _defineProperty(this, "comparator", this.defaultComparator);

    _defineProperty(this, "filterRenderer", function (onUpdateFilter) {
      return React.createElement(TextBoxFilter, {
        onUpdateFilter: onUpdateFilter
      });
    });

    _defineProperty(this, "headerRenderer", function (column) {
      return column.title;
    });

    _defineProperty(this, "locked", false);

    _defineProperty(this, "width", void 0);

    _defineProperty(this, "headerStyle", {});

    _defineProperty(this, "style", {});

    _defineProperty(this, "columnGroup", void 0);

    _defineProperty(this, "enableShowAndHide", true);

    if (options.id == null) throw new Error('Column id is required');
    if (options.valueGetter == null) throw new Error('Column value getter is required');
    this.id = options.id;
    if (options.title != null) this.title = options.title;
    if (options.valueGetter != null) this.valueGetter = options.valueGetter;
    if (options.filterable != null) this.filterable = options.filterable;
    if (options.sortable != null) this.sortable = options.sortable;
    if (options.resizable != null) this.resizable = options.resizable;
    if (options.hidden != null) this.hidden = options.hidden;
    if (options.renderer != null) this.renderer = options.renderer;
    if (options.aggregateRenderer == null) this.aggregateRenderer = this.renderer;else this.aggregateRenderer = options.aggregateRenderer;
    if (options.comparator != null) this.comparator = options.comparator;
    if (options.aggregateValueGetter != null) this.aggregateValueGetter = options.aggregateValueGetter;
    if (options.filterRenderer != null) this.filterRenderer = options.filterRenderer;
    if (options.headerRenderer != null) this.headerRenderer = options.headerRenderer;
    if (options.headerStyle != null) this.headerStyle = options.headerStyle;
    if (options.style != null) this.style = options.style;
    if (options.columnGroup != null) this.columnGroup = options.columnGroup;
    if (options.enableShowAndHide != null) this.enableShowAndHide = options.enableShowAndHide;
    this.locked = options.locked != null && options.locked;
    this.width = options.width;
  };

  var ColumnGroup = function ColumnGroup(options) {
    var _this = this;

    _classCallCheck(this, ColumnGroup);

    _defineProperty(this, "id", void 0);

    _defineProperty(this, "title", '');

    _defineProperty(this, "headerRenderer", function () {
      return _this.title;
    });

    if (options.id == null) throw new Error('ColumnGroup id is required');
    this.id = options.id;
    if (options.title != null) this.title = options.title;
    if (options.headerRenderer != null) this.headerRenderer = options.headerRenderer;
  };

  var Filter = function Filter(columnId, matcher) {
    _classCallCheck(this, Filter);

    _defineProperty(this, "columnId", void 0);

    _defineProperty(this, "matcher", void 0);

    if (columnId == null) throw new Error('Column id is required');
    if (matcher == null) throw new Error('Filter matcher is required');
    this.columnId = columnId;
    this.matcher = matcher;
  };

  var Sort = function Sort(columnId, direction) {
    _classCallCheck(this, Sort);

    _defineProperty(this, "columnId", void 0);

    _defineProperty(this, "direction", 'asc');

    if (columnId == null) throw new Error('Column id is required');
    if (direction == null) throw new Error('Direction is required');
    if (direction !== 'asc' && direction !== 'desc') throw new Error('Invalid sort direction (must be \'asc\' or \'desc\')');
    this.columnId = columnId;
    this.direction = direction;
  };

  var Group = // eslint-disable-line
  function Group(options) {
    _classCallCheck(this, Group);

    _defineProperty(this, "id", void 0);

    _defineProperty(this, "title", void 0);

    _defineProperty(this, "groupingFunction", void 0);

    _defineProperty(this, "renderer", function (v, g) {
      return React__default.createElement("span", null, g.title, ": ", React__default.createElement("b", null, v));
    });

    _defineProperty(this, "comparator", function (a, b) {
      return a === b ? 0 : a < b ? -1 : 1;
    });

    if (options.id == null) throw new Error('Group id is required');
    if (options.groupingFunction == null) throw new Error('Grouping function is required');
    this.id = options.id;
    this.groupingFunction = options.groupingFunction;
    this.title = options.title != null ? options.title : options.id;
    if (options.renderer != null) this.renderer = options.renderer;
    if (options.comparator != null) this.comparator = options.comparator;
  };

  // Unique ID creation requires a high quality random # generator.  In node.js
  // this is pretty straight-forward - we use the crypto API.



  var rng = function nodeRNG() {
    return crypto.randomBytes(16);
  };

  /**
   * Convert array of 16 byte values to UUID string format of the form:
   * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
   */
  var byteToHex = [];
  for (var i = 0; i < 256; ++i) {
    byteToHex[i] = (i + 0x100).toString(16).substr(1);
  }

  function bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return ([bth[buf[i++]], bth[buf[i++]], 
  	bth[buf[i++]], bth[buf[i++]], '-',
  	bth[buf[i++]], bth[buf[i++]], '-',
  	bth[buf[i++]], bth[buf[i++]], '-',
  	bth[buf[i++]], bth[buf[i++]], '-',
  	bth[buf[i++]], bth[buf[i++]],
  	bth[buf[i++]], bth[buf[i++]],
  	bth[buf[i++]], bth[buf[i++]]]).join('');
  }

  var bytesToUuid_1 = bytesToUuid;

  function v4(options, buf, offset) {
    var i = buf && offset || 0;

    if (typeof(options) == 'string') {
      buf = options === 'binary' ? new Array(16) : null;
      options = null;
    }
    options = options || {};

    var rnds = options.random || (options.rng || rng)();

    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = (rnds[6] & 0x0f) | 0x40;
    rnds[8] = (rnds[8] & 0x3f) | 0x80;

    // Copy bytes to buffer, if provided
    if (buf) {
      for (var ii = 0; ii < 16; ++ii) {
        buf[i + ii] = rnds[ii];
      }
    }

    return buf || bytesToUuid_1(rnds);
  }

  var v4_1 = v4;

  var DataRow = function DataRow(content, type, originalIndex, key) {
    _classCallCheck(this, DataRow);

    _defineProperty(this, "content", void 0);

    _defineProperty(this, "type", void 0);

    _defineProperty(this, "originalIndex", void 0);

    _defineProperty(this, "key", void 0);

    this.content = content;
    this.type = type;
    this.originalIndex = originalIndex;
    this.key = key != null ? key : v4_1();
  };

  var addColumnGroup = function addColumnGroup(accumulator, c) {
    return accumulator.push(c.columnGroup != null ? {
      columns: immutable.List([c]),
      columnGroup: c.columnGroup
    } : {
      columns: immutable.List([c]),
      columnGroup: null
    });
  };

  var updateColumnGroup = function updateColumnGroup(accumulator, c) {
    var lastElement = accumulator.last();
    return accumulator.pop().push({
      columns: lastElement.columns.push(c),
      columnGroup: lastElement.columnGroup
    });
  };

  var getComputedColumnGroups = function getComputedColumnGroups(columns) {
    return columns.reduce(function (accumulator, c) {
      return accumulator.size === 0 || c.columnGroup == null || accumulator.last().columnGroup !== c.columnGroup ? addColumnGroup(accumulator, c) : updateColumnGroup(accumulator, c);
    }, immutable.List());
  };

  function _templateObject5() {
    var data = _taggedTemplateLiteral(["\n  display: flex;\n"]);

    _templateObject5 = function _templateObject5() {
      return data;
    };

    return data;
  }

  function _templateObject4() {
    var data = _taggedTemplateLiteral(["\n  padding: 0 5px;\n  border-top: solid 1px #aaa;\n  white-space: nowrap;\n"]);

    _templateObject4 = function _templateObject4() {
      return data;
    };

    return data;
  }

  function _templateObject3() {
    var data = _taggedTemplateLiteral(["\n  width: 100%;\n  overflow: auto;\n  > div:nth-child(2) {\n    border-top: solid 3px #aaa;\n  }\n  > div:nth-child(3) {\n    border-top: solid 3px #aaa;\n  }\n"]);

    _templateObject3 = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2() {
    var data = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: 5px;\n  padding-bottom: 4px;\n  border-bottom: 1px solid rgb(204, 204, 204);\n\n  input {\n    width: 100%;\n    box-sizing: border-box;\n    padding: 5px;\n    background-color: #eeeeee;\n    border: solid 1px #ccc;\n  }\n  input:focus {\n    outline: none;\n  }\n"]);

    _templateObject2 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject() {
    var data = _taggedTemplateLiteral(["\n  background-color: #ddd;\n  border: solid 1px #ccc;\n  line-height: 26px;\n  max-height: 500px;\n  width: 200px;\n  display: flex;\n  flex-direction: column;\n"]);

    _templateObject = function _templateObject() {
      return data;
    };

    return data;
  }
  var columnsMenuStyle = emotion.css(_templateObject());
  var searchStyle = emotion.css(_templateObject2());
  var columnsStyle = emotion.css(_templateObject3());
  var columnGroupStyle = emotion.css(_templateObject4());
  var columnGroupHeaderStyle = emotion.css(_templateObject5());

  var ColumnsMenu =
  /*#__PURE__*/
  function (_React$PureComponent) {
    _inherits(ColumnsMenu, _React$PureComponent);

    function ColumnsMenu(props) {
      var _this;

      _classCallCheck(this, ColumnsMenu);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(ColumnsMenu).call(this, props));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "ref", void 0);

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClickOutside", function (event) {
        if (_this.ref != null && !_this.ref.contains(event.target)) _this.props.onClose();
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "filterColumns", function (searchValue) {
        _this.setState({
          searchValue: searchValue
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "filterInitialColumns", function (columns, inputValue) {
        return columns.filter(function (c) {
          return c.title.toLowerCase().includes(inputValue.toLowerCase());
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "render", function () {
        var leftLockedColumns = _this.filterInitialColumns(_this.props.leftLockedColumns, _this.state.searchValue);

        var freeColumns = _this.filterInitialColumns(_this.props.freeColumns, _this.state.searchValue);

        var rightLockedColumns = _this.filterInitialColumns(_this.props.rightLockedColumns, _this.state.searchValue);

        return React__default.createElement("div", {
          ref: function ref(_ref) {
            return _this.ref = _ref;
          },
          className: "functional-data-grid__columns-menu ".concat(columnsMenuStyle)
        }, React__default.createElement("div", {
          className: "functional-data-grid__columns-menu__search ".concat(searchStyle)
        }, React__default.createElement("input", {
          onChange: function onChange(e) {
            return _this.filterColumns(e.target.value);
          },
          placeholder: 'Search...',
          autoFocus: true
        })), React__default.createElement("div", {
          className: "functional-data-grid__columns-menu__columns ".concat(columnsStyle)
        }, leftLockedColumns.size > 0 && _this.renderColumnEntries(leftLockedColumns), freeColumns.size > 0 && React__default.createElement("div", null, _this.renderColumnEntries(freeColumns)), rightLockedColumns.size > 0 && React__default.createElement("div", null, _this.renderColumnEntries(rightLockedColumns))));
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderColumnEntries", function (columns) {
        return React__default.createElement("div", null, getComputedColumnGroups(columns).map(function (g, i) {
          return _this.renderColumnGroup(g, i);
        }));
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderColumnGroup", function (g, key) {
        var columnGroup = g.columnGroup;
        return React__default.createElement("div", {
          key: key
        }, columnGroup != null ? React__default.createElement("div", {
          className: "functional-data-grid__columns-menu__column-group ".concat(columnGroupStyle)
        }, React__default.createElement("div", {
          className: "functional-data-grid__columns-menu__column-group__header ".concat(columnGroupHeaderStyle)
        }, React__default.createElement("span", {
          style: {
            fontWeight: 'bold',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          },
          title: _this.getColumnGroupById(columnGroup).title
        }, _this.getColumnGroupById(columnGroup).title)), g.columns.map(function (c) {
          return _this.renderColumnEntry(c);
        })) : React__default.createElement("div", {
          style: {
            padding: '0 5px',
            whiteSpace: 'nowrap'
          }
        }, g.columns.map(function (c) {
          return _this.renderColumnEntry(c);
        })));
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderColumnEntry", function (c) {
        return React__default.createElement("div", {
          key: c.id,
          className: "functional-data-grid__columns-menu__column",
          draggable: _this.props.enableColumnsSorting,
          onDragStart: _this.onDragStart(c.id),
          onDragOver: _this.onDragOver,
          onDrop: _this.onDrop(c.id),
          style: {
            cursor: _this.props.enableColumnsSorting ? 'pointer' : 'auto',
            display: 'flex'
          }
        }, _this.props.enableColumnsSorting && React__default.createElement("div", {
          style: {
            paddingRight: '4px',
            color: '#999'
          }
        }, String.fromCodePoint(9776)), React__default.createElement("div", {
          style: {
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center'
          },
          title: c.title
        }, _this.props.enableColumnsShowAndHide && c.enableShowAndHide && React__default.createElement("input", {
          type: "checkbox",
          checked: _this.props.columnsVisibility.get(c.id),
          onChange: _this.onColumnVisibilityChange(c.id),
          style: {
            margin: 0,
            marginRight: '2px'
          }
        }), React__default.createElement("span", {
          style: {
            textOverflow: 'ellipsis',
            overflow: 'hidden'
          }
        }, c.title)));
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onDragOver", function (event) {
        event.preventDefault();
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onDragStart", function (columnId) {
        return function (event) {
          event.dataTransfer.setData('columnId', columnId);
        };
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onDrop", function (columnId) {
        return function (event) {
          var sourceColumnId = event.dataTransfer.getData('columnId');
          var targetColumnId = columnId;

          _this.props.onColumnsOrderChange(_this.moveColumnBefore(sourceColumnId, targetColumnId));

          event.dataTransfer.clearData();
        };
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "moveColumnBefore", function (sourceColumnId, targetColumnId) {
        var sourceColumnIndex = _this.props.columnsOrder.findIndex(function (co) {
          return co === sourceColumnId;
        });

        var columnsOrderWithoutSourceColumn = _this.props.columnsOrder.delete(sourceColumnIndex);

        var targetColumnIndex = columnsOrderWithoutSourceColumn.findIndex(function (co) {
          return co === targetColumnId;
        });
        return columnsOrderWithoutSourceColumn.insert(targetColumnIndex + (sourceColumnIndex > targetColumnIndex ? 0 : 1), sourceColumnId);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onColumnVisibilityChange", function (columnId) {
        return function (event) {
          _this.props.onColumnVisibilityChange(columnId, event.target.checked);
        };
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getColumnGroupById", function (id) {
        return _this.props.columnGroups.find(function (g) {
          return g.id === id;
        });
      });

      _this.state = {
        searchValue: ''
      };
      return _this;
    }

    _createClass(ColumnsMenu, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        document.addEventListener('click', this.handleClickOutside, true);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside, true);
      }
    }]);

    return ColumnsMenu;
  }(React__default.PureComponent);

  _defineProperty(ColumnsMenu, "defaultProps", {
    enableColumnsShowAndHide: false,
    enableColumnsSorting: false,
    onColumnVisibilityChange: function onColumnVisibilityChange() {},
    onColumsOrderChange: function onColumsOrderChange(columnsOrder) {},
    onClose: function onClose() {}
  });

  var HeaderColumnResizer =
  /*#__PURE__*/
  function (_React$PureComponent) {
    _inherits(HeaderColumnResizer, _React$PureComponent);

    function HeaderColumnResizer(props) {
      var _this;

      _classCallCheck(this, HeaderColumnResizer);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(HeaderColumnResizer).call(this, props));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "element", void 0);

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "render", function () {
        var style = {
          position: 'absolute',
          right: '-10px',
          top: 0,
          bottom: 0,
          width: '20px',
          backgroundColor: 'transparent',
          cursor: 'col-resize',
          opacity: 0,
          zIndex: 1
        };
        if (_this.state.clicked || _this.state.hover) style.opacity = 1;
        return React__default.createElement("div", {
          ref: function ref(el) {
            return _this.element = el;
          },
          style: style,
          onMouseDown: _this.onMouseDown,
          onMouseEnter: _this.onMouseEnter,
          onMouseLeave: _this.onMouseLeave
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMouseEnter", function () {
        _this.setState({
          hover: true
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMouseLeave", function () {
        _this.setState({
          hover: false
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMouseDown", function (e) {
        e.preventDefault();

        if (document.body != null) {
          _this.setState({
            clicked: true
          });

          var diff = e.clientX - _this.props.right;

          var mouseMoveListener = function mouseMoveListener(e) {
            var currentPosition = e.clientX - diff;

            _this.props.onResize(currentPosition);
          };

          if (document.body != null) document.body.addEventListener('mousemove', mouseMoveListener);

          var mouseUpOutListener = function mouseUpOutListener(e) {
            _this.setState({
              clicked: false
            });

            if (document.body != null) document.body.removeEventListener('mousemove', mouseMoveListener);
            if (document.body != null) document.body.removeEventListener('mouseup', mouseUpOutListener);
          };

          if (document.body != null) document.body.addEventListener('mouseup', mouseUpOutListener);
        }
      });

      _this.state = {
        clicked: false,
        hover: false
      };
      return _this;
    }

    return HeaderColumnResizer;
  }(React__default.PureComponent);

  function _templateObject3$1() {
    var data = _taggedTemplateLiteral(["\n  text-align: center;\n  margin-top: 2px;\n"]);

    _templateObject3$1 = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2$1() {
    var data = _taggedTemplateLiteral(["\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n"]);

    _templateObject2$1 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject$1() {
    var data = _taggedTemplateLiteral(["\n  overflow: visible;\n  text-overflow: ellipsis;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 8px;\n  border-right: solid 1px #ccc;\n  position: relative;\n"]);

    _templateObject$1 = function _templateObject() {
      return data;
    };

    return data;
  }
  var headerColumnStyle = emotion.css(_templateObject$1());
  var headerColumnTitleStyle = emotion.css(_templateObject2$1());
  var headerColumnFilterStyle = emotion.css(_templateObject3$1());

  var HeaderColumn =
  /*#__PURE__*/
  function (_React$PureComponent) {
    _inherits(HeaderColumn, _React$PureComponent);

    function HeaderColumn(props) {
      var _this;

      _classCallCheck(this, HeaderColumn);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(HeaderColumn).call(this, props));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "element", void 0);

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "render", function () {
        var right = _this.element == null ? 0 : _this.element.getBoundingClientRect().right;
        return React__default.createElement("div", {
          ref: function ref(el) {
            return _this.element = el;
          },
          key: _this.props.column.id,
          className: headerColumnStyle,
          style: Object.assign(_this.getCellStyle(_this.props.column), _this.props.column.headerStyle)
        }, _this.props.column.resizable && React__default.createElement(HeaderColumnResizer, {
          right: right,
          onResize: _this.onColumnResize
        }), React__default.createElement("div", {
          onClick: _this.toggleSortDirection,
          className: headerColumnTitleStyle
        }, _this.props.column.headerRenderer(_this.props.column), React__default.createElement("span", null, " ", _this.state.direction === 'asc' ? '▲' : _this.state.direction === 'desc' ? '▼' : '')), _this.props.column.filterable && React__default.createElement("div", {
          className: headerColumnFilterStyle
        }, _this.props.column.filterRenderer(_this.triggerOnUpdateFilter)));
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "toggleSortDirection", function () {
        if (_this.props.column.sortable) {
          _this.setState({
            direction: _this.nextSortDirection(_this.state.direction)
          }, function () {
            return _this.props.onUpdateSort(_this.props.column.id, _this.state.direction);
          });
        }
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "nextSortDirection", function (direction) {
        return direction === 'none' ? 'asc' : direction === 'asc' ? 'desc' : 'none';
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "triggerOnUpdateFilter", function (matcher) {
        _this.props.onUpdateFilter(_this.props.column.id, matcher);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getCellStyle", function (c) {
        var styles = {};
        if (_this.props.width != null) styles.width = _this.props.width;
        if (c.sortable === true) styles.cursor = 'pointer';
        return styles;
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onColumnResize", function (right) {
        _this.props.onColumnResize(right - _this.element.getBoundingClientRect().left);
      });

      _this.state = {
        direction: _this.props.direction
      };
      return _this;
    }

    return HeaderColumn;
  }(React__default.PureComponent);

  _defineProperty(HeaderColumn, "defaultProps", {
    direction: 'none'
  });

  function _templateObject4$1() {
    var data = _taggedTemplateLiteral(["\n  flex-shrink: 0;\n"]);

    _templateObject4$1 = function _templateObject4() {
      return data;
    };

    return data;
  }

  function _templateObject3$2() {
    var data = _taggedTemplateLiteral(["\n  display: flex;\n"]);

    _templateObject3$2 = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2$2() {
    var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-grow: 1;\n"]);

    _templateObject2$2 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject$2() {
    var data = _taggedTemplateLiteral(["\n  display: flex;\n"]);

    _templateObject$2 = function _templateObject() {
      return data;
    };

    return data;
  }
  var leftLockedClassName = emotion.css(_templateObject$2());
  var freeClassName = emotion.css(_templateObject2$2());
  var rightLockedClassName = emotion.css(_templateObject3$2());
  var rightClassName = emotion.css(_templateObject4$1());

  var RowSkeleton =
  /*#__PURE__*/
  function (_React$PureComponent) {
    _inherits(RowSkeleton, _React$PureComponent);

    function RowSkeleton(props) {
      var _this;

      _classCallCheck(this, RowSkeleton);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(RowSkeleton).call(this, props));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentDidUpdate", function (prevProps) {
        var scrollingDiv = _this.state.scrollingDiv;
        if (scrollingDiv != null && _this.props.scrollLeft !== scrollingDiv.scrollLeft) _this.updateScroll();
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentDidUpdate", function (prevProps) {
        var scrollingDiv = _this.state.scrollingDiv;
        if (scrollingDiv != null && _this.props.scrollLeft !== scrollingDiv.scrollLeft) _this.updateScroll();
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentDidUpdate", function (prevProps) {
        var scrollingDiv = _this.state.scrollingDiv;
        if (scrollingDiv != null && _this.props.scrollLeft !== scrollingDiv.scrollLeft) _this.updateScroll();
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "updateScroll", function () {
        var scrollingDiv = _this.state.scrollingDiv;
        if (scrollingDiv != null) scrollingDiv.scrollLeft = _this.props.scrollLeft;
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "triggerOnScroll", function (event) {
        var scrollEvent = {
          scrollLeft: event.target.scrollLeft
        };
        if (_this.props.onScroll != null) _this.props.onScroll(scrollEvent);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "render", function () {
        var _this$props = _this.props,
            leftLocked = _this$props.leftLocked,
            free = _this$props.free,
            rightLocked = _this$props.rightLocked,
            right = _this$props.right,
            scrollLeft = _this$props.scrollLeft,
            onScroll = _this$props.onScroll,
            scrollbar = _this$props.scrollbar,
            rightWidth = _this$props.rightWidth,
            otherProps = _objectWithoutProperties(_this$props, ["leftLocked", "free", "rightLocked", "right", "scrollLeft", "onScroll", "scrollbar", "rightWidth"]);

        return React.createElement("div", otherProps, React.createElement("div", {
          className: "functional-data-grid__row__left-locked ".concat(leftLockedClassName)
        }, leftLocked), React.createElement("div", {
          className: "functional-data-grid__row__free ".concat(freeClassName),
          style: {
            overflow: scrollbar ? 'auto' : 'hidden'
          },
          ref: function ref(el) {
            return _this.setState({
              scrollingDiv: el
            }, function () {
              return _this.updateScroll();
            });
          },
          onScroll: _this.triggerOnScroll
        }, free), React.createElement("div", {
          className: "functional-data-grid__row__right-locked ".concat(rightLockedClassName)
        }, rightLocked), React.createElement("div", {
          className: "functional-data-grid__row__right ".concat(rightClassName),
          style: {
            width: "".concat(rightWidth, "px")
          }
        }, right));
      });

      _this.state = {
        scrollingDiv: null
      };
      return _this;
    }

    return RowSkeleton;
  }(React.PureComponent);

  _defineProperty(RowSkeleton, "defaultProps", {
    leftLocked: null,
    free: null,
    rightLocked: null,
    right: null,
    scrollbar: false,
    onScroll: function onScroll() {},
    scrollLeft: 0
  });

  var Constants = {
    columnsOptionsWidth: 26,
    defaultFooterHeight: 22
  };

  function _templateObject$3() {
    var data = _taggedTemplateLiteral(["\n  flex-shrink: 0;\n  padding: 8px;\n  border-right: solid 1px #ccc;\n"]);

    _templateObject$3 = function _templateObject() {
      return data;
    };

    return data;
  }
  var columnGroupHeaderStyle$1 = emotion.css(_templateObject$3());

  var ColumnGroupsHeader =
  /*#__PURE__*/
  function (_React$PureComponent) {
    _inherits(ColumnGroupsHeader, _React$PureComponent);

    function ColumnGroupsHeader(props) {
      var _this;

      _classCallCheck(this, ColumnGroupsHeader);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(ColumnGroupsHeader).call(this, props));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "render", function () {
        return _this.renderColumnGroupsHeader(_this.props.style);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderColumnGroupsHeader", function (style) {
        return _this.props.columnGroups.size > 0 && React.createElement(RowSkeleton, {
          className: _this.props.className,
          key: 1,
          style: _objectSpread({}, style, _this.props.style),
          leftLocked: _this.renderColumnGroupsHeaderForColumns(_this.props.leftLockedColumns),
          free: _this.renderColumnGroupsHeaderForColumns(_this.props.freeColumns),
          rightLocked: _this.renderColumnGroupsHeaderForColumns(_this.props.rightLockedColumns),
          scrollLeft: _this.props.scrollLeft,
          onScroll: _this.props.onScroll,
          rightWidth: Constants.columnsOptionsWidth
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderColumnGroupHeader", function (c, index) {
        return React.createElement("div", {
          className: columnGroupHeaderStyle$1,
          style: {
            width: "".concat(_this.getColumnsWidth(c.columns), "px")
          },
          key: index
        }, c.columnGroup != null && _this.getColumnGroupById(c.columnGroup).headerRenderer());
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderColumnGroupsHeaderForColumns", function (columns) {
        return getComputedColumnGroups(columns).map(function (g, index) {
          return _this.renderColumnGroupHeader(g, index);
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getColumnGroupById", function (id) {
        return _this.props.columnGroups.find(function (g) {
          return g.id === id;
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getColumnsWidth", function (columns) {
        return columns.reduce(function (accumulator, c) {
          return accumulator + _this.getColumnWidth(c);
        }, 0);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getColumnWidth", function (c) {
        return _this.props.columnsWidth.get(c.id) != null ? _this.props.columnsWidth.get(c.id) : c.width;
      });

      return _this;
    }

    return ColumnGroupsHeader;
  }(React.PureComponent);

  function _templateObject$4() {
    var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-grow: 0;\n  width: 100%;\n  background-color: #ddd;\n  position: relative;\n  border-bottom: solid 1px #ccc;\n"]);

    _templateObject$4 = function _templateObject() {
      return data;
    };

    return data;
  }
  var headerStyle = emotion.css(_templateObject$4());

  var Header =
  /*#__PURE__*/
  function (_React$PureComponent) {
    _inherits(Header, _React$PureComponent);

    function Header() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, Header);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Header)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "render", function () {
        return [React.createElement(ColumnGroupsHeader, {
          key: 1,
          leftLockedColumns: _this.props.leftLockedColumns,
          freeColumns: _this.props.freeColumns,
          rightLockedColumns: _this.props.rightLockedColumns,
          columnGroups: _this.props.columnGroups,
          scrollLeft: _this.props.scrollLeft,
          onScroll: _this.props.onScroll,
          columnsWidth: _this.props.columnsWidth,
          className: "functional-data-grid__column-groups-header ".concat(headerStyle),
          style: _this.props.style
        }), _this.renderHeader(_this.props.leftLockedColumns, _this.props.freeColumns, _this.props.rightLockedColumns)];
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderHeader", function (leftLockedColumns, freeColumns, rightLockedColumns) {
        return React.createElement(RowSkeleton, {
          key: 2,
          className: "functional-data-grid__header ".concat(headerStyle),
          style: _this.props.style,
          leftLocked: _this.renderColumns(leftLockedColumns),
          free: _this.renderColumns(freeColumns),
          rightLocked: _this.renderColumns(rightLockedColumns),
          right: _this.props.columnsMenu,
          scrollLeft: _this.props.scrollLeft,
          onScroll: _this.props.onScroll,
          rightWidth: Constants.columnsOptionsWidth
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderColumns", function (columns) {
        return columns.map(function (c, index) {
          return _this.renderColumn(c);
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getColumnWidth", function (c) {
        return _this.props.columnsWidth.get(c.id) != null ? _this.props.columnsWidth.get(c.id) : c.width;
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderColumn", function (c) {
        return React.createElement(HeaderColumn, {
          key: c.id,
          column: c,
          width: _this.getColumnWidth(c),
          direction: _this.getSortDirection(c.id),
          onUpdateSort: _this.props.onUpdateSort,
          onUpdateFilter: _this.props.onUpdateFilter,
          onColumnResize: function onColumnResize(width) {
            return _this.props.onColumnResize(c.id, width);
          }
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getSortDirection", function (columnId) {
        var sort = _this.props.sort.find(function (c) {
          return c.columnId === columnId;
        });

        return sort == null ? 'none' : sort.direction;
      });

      return _this;
    }

    return Header;
  }(React.PureComponent);

  function _templateObject2$3() {
    var data = _taggedTemplateLiteral(["\n  overflow: hidden;\n  flex-shrink: 0;\n  padding: 2px 10px;\n  position: relative;\n  display: flex;\n"]);

    _templateObject2$3 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject$5() {
    var data = _taggedTemplateLiteral(["\n  background-color: inherit;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  align-self: center;\n  width: 100%;\n"]);

    _templateObject$5 = function _templateObject() {
      return data;
    };

    return data;
  }
  var contentClassName = emotion.css(_templateObject$5());
  var cellClassName = emotion.css(_templateObject2$3());

  var Cell =
  /*#__PURE__*/
  function (_React$PureComponent) {
    _inherits(Cell, _React$PureComponent);

    function Cell(props) {
      var _this;

      _classCallCheck(this, Cell);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Cell).call(this, props));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "render", function () {
        return React__default.createElement("div", {
          className: "functional-data-grid__cell ".concat(cellClassName),
          style: _objectSpread({}, _this.getCellStyle(), _this.props.column.style, _this.props.style),
          onMouseEnter: _this.onMouseEnter,
          onMouseLeave: _this.onMouseLeave
        }, React__default.createElement("div", {
          className: "functional-data-grid__cell-content ".concat(contentClassName)
        }, _this.renderValue(_this.props.column, _this.props.type, _this.props.content, _this.props.originalIndex)));
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMouseEnter", function () {
        return _this.setState({
          'hover': true
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMouseLeave", function () {
        return _this.setState({
          'hover': false
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderValue", function (c, type, content, originalIndex) {
        return type === 'aggregate' ? _this.props.value == null ? React__default.createElement("span", null) : c.aggregateRenderer(_this.props.value, content, _this.props.rowIndex, originalIndex, _this.props.rowHover, _this.state.hover) : c.renderer(_this.props.value, content, _this.props.rowIndex, originalIndex, _this.props.rowHover, _this.state.hover);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getCellStyle", function () {
        var styles = {};

        if (_this.state.hover) {
          styles.overflow = 'visible';
        }

        if (_this.props.width != null) styles.width = _this.props.width;
        return styles;
      });

      _this.state = {
        hover: false
      };
      return _this;
    }

    return Cell;
  }(React__default.PureComponent);

  function _templateObject2$4() {
    var data = _taggedTemplateLiteral(["\n  overflow: hidden;\n  flex-shrink: 0;\n  padding: 2px 10px;\n  position: relative;\n"]);

    _templateObject2$4 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject$6() {
    var data = _taggedTemplateLiteral(["\n  display: flex;\n  border-bottom: solid 1px #eee;\n  line-height: 25px;\n  background-color: #fff;\n  &:hover {\n    background-color: #fafafa;\n  }\n"]);

    _templateObject$6 = function _templateObject() {
      return data;
    };

    return data;
  }
  var rowClassName = emotion.css(_templateObject$6());
  var groupClassName = emotion.css(_templateObject2$4());

  var Row =
  /*#__PURE__*/
  function (_React$PureComponent) {
    _inherits(Row, _React$PureComponent);

    function Row(props) {
      var _this;

      _classCallCheck(this, Row);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Row).call(this, props));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "render", function () {
        return _this.props.element.type === 'group-header' ? _this.groupHeaderRowRenderer(_this.props.style, _this.props.element, _this.props.groups, _this.onMouseOver, _this.onMouseOut) : _this.elementsRowRenderer(_this.props.rowIndex, _this.props.element, _this.props.leftLockedColumns, _this.props.freeColumns, _this.props.rightLockedColumns, _this.onMouseOver, _this.onMouseOut, _this.state.hover, _this.props.cellStyle, _this.props.style, _this.getColumnWidth);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "groupHeaderRowRenderer", function (style, element, groups, onMouseOver, onMouseOut) {
        return React__default.createElement(RowSkeleton, {
          className: "".concat(rowClassName, " functional-data-grid__row functional-data-grid__row--group-header"),
          onMouseEnter: onMouseOver,
          onMouseLeave: onMouseOut,
          style: style,
          onClick: _this.props.onClick,
          leftLocked: React__default.createElement("div", {
            className: groupClassName
          }, _this.renderGroups(element, groups)),
          rightWidth: Constants.columnsOptionsWidth - _this.props.scrollbarWidth
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderGroups", function (element, groups) {
        var entries = immutable.List(Object.entries(element.content));
        return entries.map(function (e, index) {
          return React__default.createElement("div", {
            key: index,
            style: {
              display: 'inline-block',
              marginRight: '10px'
            }
          }, _this.renderGroup(groups.find(function (g) {
            return g.id === e[0];
          }), e[1]));
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderGroup", function (group, v) {
        return group.renderer(v, group);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "elementsRowRenderer", function (rowIndex, element, leftLockedColumns, freeColumns, rightLockedColumns, onMouseOver, onMouseOut, hover, cellStyle, style, columnWidthGetter) {
        return _this.renderElementsRow(leftLockedColumns, freeColumns, rightLockedColumns, rowIndex, element, onMouseOver, onMouseOut, hover, cellStyle, style, columnWidthGetter);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderElementsRow", function (leftLockedColumns, freeColumns, rightLockedColumns, rowIndex, element, onMouseOver, onMouseOut, hover, cellStyle, style, columnWidthGetter) {
        return React__default.createElement(RowSkeleton, {
          "data-index": rowIndex,
          "data-original-index": element.originalIndex,
          className: "".concat(rowClassName, " functional-data-grid__row functional-data-grid__row--").concat(element.type),
          onMouseEnter: onMouseOver,
          onMouseLeave: onMouseOut,
          style: style,
          leftLocked: _this.renderCells(leftLockedColumns, hover, element, rowIndex, cellStyle, columnWidthGetter),
          free: _this.renderCells(freeColumns, hover, element, rowIndex, cellStyle, columnWidthGetter),
          rightLocked: _this.renderCells(rightLockedColumns, hover, element, rowIndex, cellStyle, columnWidthGetter),
          scrollLeft: _this.props.scrollLeft,
          onScroll: _this.props.onScroll,
          onClick: _this.props.onClick,
          rightWidth: Constants.columnsOptionsWidth - _this.props.scrollbarWidth
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderCells", function (columns, hover, element, rowIndex, cellStyle, columnWidthGetter) {
        return columns.map(function (c) {
          var value = _this.computeValue(c, element);

          return React__default.createElement(Cell, {
            value: value,
            key: c.id,
            rowHover: hover,
            column: c,
            width: columnWidthGetter(c),
            rowIndex: rowIndex,
            style: cellStyle,
            type: element.type,
            content: element.content,
            originalIndex: element.originalIndex != null ? element.originalIndex : -1
          });
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "computeValue", function (c, e) {
        return e.type === 'aggregate' ? c.aggregateValueGetter == null ? null : c.aggregateValueGetter(e.content.content, e.content.key) : c.valueGetter(e.content);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getColumnWidth", function (c) {
        return _this.props.columnsWidth.get(c.id);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMouseOver", function () {
        _this.setState({
          hover: true
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMouseOut", function () {
        _this.setState({
          hover: false
        });
      });

      _this.state = {
        hover: false
      };
      return _this;
    }

    return Row;
  }(React__default.PureComponent);

  function _templateObject$7() {
    var data = _taggedTemplateLiteral(["\n  background-color: #eee;\n  text-align: right;\n  font-style: italic;\n  flex-shrink: 0;\n  flex-grow: 0;\n  padding: 2px 10px;\n"]);

    _templateObject$7 = function _templateObject() {
      return data;
    };

    return data;
  }
  var footerStyle = emotion.css(_templateObject$7());

  var Footer =
  /*#__PURE__*/
  function (_React$PureComponent) {
    _inherits(Footer, _React$PureComponent);

    function Footer() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, Footer);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Footer)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getStyle", function () {
        return _objectSpread({}, _this.props.style, {
          lineHeight: Constants.defaultFooterHeight + 'px',
          height: Constants.defaultFooterHeight + 'px'
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "render", function () {
        return React__default.createElement("div", {
          className: "functional-data-grid__footer ".concat(footerStyle),
          style: _this.getStyle()
        }, _this.props.totalElements, " elements");
      });

      return _this;
    }

    return Footer;
  }(React__default.PureComponent);

  function _templateObject2$5() {
    var data = _taggedTemplateLiteral(["\n  flex-shrink: 0;\n  min-height: 1px;\n"]);

    _templateObject2$5 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject$8() {
    var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-grow: 0;\n  width: 100%;\n  background-color: transparent;\n  position: relative;\n  border-bottom: solid 1px #ccc;\n"]);

    _templateObject$8 = function _templateObject() {
      return data;
    };

    return data;
  }
  var horizontalScrollbarStyle = emotion.css(_templateObject$8());
  var emptyDivStyle = emotion.css(_templateObject2$5());

  var HorizontalScrollbar =
  /*#__PURE__*/
  function (_React$PureComponent) {
    _inherits(HorizontalScrollbar, _React$PureComponent);

    function HorizontalScrollbar() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, HorizontalScrollbar);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(HorizontalScrollbar)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "render", function () {
        return React__default.createElement(RowSkeleton, {
          className: "functional-data-grid__horizontal-scrollbar ".concat(horizontalScrollbarStyle),
          leftLocked: _this.renderEmptyDiv(_this.props.leftLockedColumnsWidth),
          free: _this.renderEmptyDiv(_this.props.freeColumnsWidth),
          rightLocked: _this.renderEmptyDiv(_this.props.rightLockedColumnsWidth),
          onScroll: _this.props.onScroll,
          scrollLeft: _this.props.scrollLeft,
          scrollbar: true,
          rightWidth: Constants.columnsOptionsWidth
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderEmptyDiv", function (width) {
        return React__default.createElement("div", {
          className: emptyDivStyle,
          style: {
            width: "".concat(width, "px")
          }
        });
      });

      return _this;
    }

    return HorizontalScrollbar;
  }(React__default.PureComponent);

  function _templateObject4$2() {
    var data = _taggedTemplateLiteral(["\n  z-index: 1;\n"]);

    _templateObject4$2 = function _templateObject4() {
      return data;
    };

    return data;
  }

  function _templateObject3$3() {
    var data = _taggedTemplateLiteral(["\n  flex-grow: 1;\n"]);

    _templateObject3$3 = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2$6() {
    var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n"]);

    _templateObject2$6 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject$9() {
    var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-grow: 1;\n  flex-direction: column;\n  box-sizing: border-box;\n  *, *:before, *:after {\n    box-sizing: inherit;\n  }\n  border: solid 1px #ccc;\n"]);

    _templateObject$9 = function _templateObject() {
      return data;
    };

    return data;
  }
  var gridClassName = emotion.css(_templateObject$9());
  var layoutContainerClassName = emotion.css(_templateObject2$6());
  var rowsContainerClassName = emotion.css(_templateObject3$3());
  var emptyObject = {};
  var columnsVisibilityMenuStyle = emotion.css(_templateObject4$2());

  var PresentationalFunctionalDataGrid =
  /*#__PURE__*/
  function (_React$PureComponent) {
    _inherits(PresentationalFunctionalDataGrid, _React$PureComponent);

    function PresentationalFunctionalDataGrid(props) {
      var _this;

      _classCallCheck(this, PresentationalFunctionalDataGrid);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(PresentationalFunctionalDataGrid).call(this, props));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "list", void 0);

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "updateScrollbarWidth", function (width) {
        _this.setState({
          scrollbarWidth: width
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "render", function () {
        return React__default.createElement("div", {
          ref: function ref(_ref3) {
            return _this.setState({
              ref: _ref3
            });
          },
          className: "functional-data-grid ".concat(_this.props.className, " ").concat(gridClassName),
          style: _objectSpread({
            height: _this.props.height
          }, _this.props.style.grid != null ? _this.props.style.grid : {})
        }, React__default.createElement(reactVirtualized.ScrollSync, null, function (_ref) {
          var clientHeight = _ref.clientHeight,
              clientWidth = _ref.clientWidth,
              onScroll = _ref.onScroll,
              scrollHeight = _ref.scrollHeight,
              scrollLeft = _ref.scrollLeft,
              scrollTop = _ref.scrollTop,
              scrollWidth = _ref.scrollWidth;
          return React__default.createElement("div", {
            className: "functional-data-grid__layout-container ".concat(layoutContainerClassName)
          }, React__default.createElement(Header, {
            leftLockedColumns: _this.getSortedColumns(_this.getLeftLockedColumns()).filter(function (c) {
              return _this.isColumnVisible(c.id);
            }),
            freeColumns: _this.getSortedColumns(_this.getFreeColumns()).filter(function (c) {
              return _this.isColumnVisible(c.id);
            }),
            rightLockedColumns: _this.getSortedColumns(_this.getRightLockedColumns()).filter(function (c) {
              return _this.isColumnVisible(c.id);
            }),
            columnsWidth: _this.props.columnsWidth,
            scrollLeft: scrollLeft,
            onScroll: onScroll,
            style: _this.props.style.header != null ? _this.props.style.header : {},
            sort: _this.props.sort,
            onUpdateSort: _this.props.onUpdateSort,
            onUpdateFilter: _this.props.onUpdateFilter,
            onColumnResize: _this.props.onColumnResize,
            enableColumnsShowAndHide: _this.props.enableColumnsShowAndHide,
            enableColumnsSorting: _this.props.enableColumnsSorting,
            columnsMenu: _this.props.enableColumnsShowAndHide || _this.props.enableColumnsSorting ? _this.getColumnsMenu() : React__default.createElement("div", {
              style: {
                flexShrink: 0,
                width: '26px'
              }
            }),
            columnGroups: _this.props.columnGroups
          }), React__default.createElement("div", {
            className: "functional-data-grid__rows-container ".concat(rowsContainerClassName)
          }, React__default.createElement(reactVirtualized.AutoSizer, null, function (_ref2) {
            var height = _ref2.height,
                width = _ref2.width;
            return React__default.createElement(reactVirtualized.List, {
              rowCount: _this.getTotalCount(),
              height: height,
              width: width,
              rowHeight: _this.getRowHeight(),
              rowRenderer: _this.rowRenderer(scrollLeft, onScroll),
              ref: function ref(list) {
                _this.list = list;
              },
              style: {
                backgroundColor: '#fff',
                outline: 'none'
              },
              overscanRowCount: _this.props.overscanRowCount,
              onScrollbarPresenceChange: function onScrollbarPresenceChange(e) {
                _this.updateScrollbarWidth(e.vertical ? e.size : 0);
              } //eslint-disable-line

            });
          })), React__default.createElement(HorizontalScrollbar, {
            columnsVisibility: _this.props.columnsVisibility,
            leftLockedColumnsWidth: _this.getColumnsWidth(_this.getLeftLockedColumns().filter(function (c) {
              return _this.isColumnVisible(c.id);
            })),
            freeColumnsWidth: _this.getColumnsWidth(_this.getFreeColumns().filter(function (c) {
              return _this.isColumnVisible(c.id);
            })),
            rightLockedColumnsWidth: _this.getColumnsWidth(_this.getRightLockedColumns().filter(function (c) {
              return _this.isColumnVisible(c.id);
            })),
            columnsWidth: _this.props.columnsWidth,
            scrollLeft: scrollLeft,
            onScroll: onScroll
          }), _this.props.showFooter && React__default.createElement(Footer, {
            style: _this.props.style.footer != null ? _this.props.style.footer : {},
            totalElements: _this.getElements().filter(function (r) {
              return r.type === 'element';
            }).size
          }));
        }));
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getColumnsWidth", function (columns) {
        return columns.reduce(function (accumulator, c) {
          return accumulator + _this.getColumnWidth(c);
        }, 0);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getColumnWidth", function (c) {
        return _this.props.columnsWidth.get(c.id) != null ? _this.props.columnsWidth.get(c.id) : c.width;
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getRowHeight", function () {
        var rowHeight = _this.props.rowHeight;
        return rowHeight instanceof Function ? function (args) {
          var element = _this.getElement(args.index);

          return rowHeight(element.content, element.originalIndex, element.type);
        } : rowHeight;
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isColumnVisible", function (columnId) {
        return _this.props.columnsVisibility.get(columnId);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getFirstFreeColumnIndex", function (columns) {
        return columns.findIndex(function (c) {
          return !c.locked;
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getLeftLockedColumns", function () {
        return _this.props.columns.filter(function (c, index) {
          return c.locked && (_this.getFirstFreeColumnIndex(_this.props.columns) === -1 || index < _this.getFirstFreeColumnIndex(_this.props.columns));
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getFreeColumns", function () {
        return _this.props.columns.filter(function (c) {
          return !c.locked;
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getRightLockedColumns", function () {
        return _this.props.columns.filter(function (c, index) {
          return c.locked && _this.getFirstFreeColumnIndex(_this.props.columns) !== -1 && index >= _this.getFirstFreeColumnIndex(_this.props.columns);
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getSortedColumns", function (columns) {
        return _this.props.columnsOrder.map(function (columnId) {
          return columns.find(function (c) {
            return c.id === columnId;
          });
        }).filter(function (e) {
          return e != null;
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "rowRenderer", function (scrollLeft, onScroll) {
        return function (param) {
          var element = _this.getElement(param.index);

          var rowStyle = _this.props.style.row != null ? _this.props.style.row(element) : emptyObject;

          var computedStyle = _objectSpread({}, param.style, rowStyle);

          return React__default.createElement(Row, {
            key: element.key,
            style: computedStyle,
            cellStyle: _this.props.style.cell != null ? _this.props.style.cell : function () {
              return emptyObject;
            },
            groups: _this.props.groups,
            leftLockedColumns: _this.getSortedColumns(_this.getLeftLockedColumns()).filter(function (c) {
              return _this.isColumnVisible(c.id);
            }),
            freeColumns: _this.getSortedColumns(_this.getFreeColumns()).filter(function (c) {
              return _this.isColumnVisible(c.id);
            }),
            rightLockedColumns: _this.getSortedColumns(_this.getRightLockedColumns()).filter(function (c) {
              return _this.isColumnVisible(c.id);
            }),
            columnsWidth: _this.props.columnsWidth,
            element: element,
            onScroll: onScroll,
            scrollLeft: scrollLeft,
            rowIndex: param.index,
            onClick: function onClick(e) {
              _this.props.onRowClick({
                row: element
              });
            },
            scrollbarWidth: _this.state.scrollbarWidth
          });
        };
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getPopperContainer", function () {
        return _this.state.ref != null ? _this.state.ref : document.body;
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "toggleColumnsMenu", function () {
        _this.setState({
          showColumnsMenu: !_this.state.showColumnsMenu
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getColumnsMenu", function () {
        return React__default.createElement(reactPopper.Manager, null, React__default.createElement(reactPopper.Reference, null, function (_ref4) {
          var ref = _ref4.ref;
          return React__default.createElement("div", {
            ref: ref,
            style: {
              padding: '5px',
              cursor: 'pointer',
              userSelect: 'none',
              fontSize: '16px'
            },
            onClick: _this.toggleColumnsMenu
          }, "\u22EE");
        }), _this.state.showColumnsMenu && _this.renderColumnsMenuPopper(_this.getPopperContainer()));
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderColumnsMenuPopper", function (popperContainer) {
        return popperContainer != null && ReactDOM.createPortal(React__default.createElement(reactPopper.Popper, {
          placement: 'bottom-end',
          modifiers: {
            preventOverflow: {
              enabled: false
            },
            hide: {
              enabled: false
            },
            flip: {
              enabled: false
            }
          }
        }, function (_ref5) {
          var placement = _ref5.placement,
              ref = _ref5.ref,
              style = _ref5.style;
          return React__default.createElement("div", {
            ref: ref,
            style: style,
            "data-placement": placement,
            className: "functional-data-grid__columns-visibility-menu ".concat(columnsVisibilityMenuStyle)
          }, React__default.createElement(ColumnsMenu, {
            leftLockedColumns: _this.getSortedColumns(_this.getLeftLockedColumns()),
            freeColumns: _this.getSortedColumns(_this.getFreeColumns()),
            rightLockedColumns: _this.getSortedColumns(_this.getRightLockedColumns()),
            columnGroups: _this.props.columnGroups,
            enableColumnsShowAndHide: _this.props.enableColumnsShowAndHide,
            enableColumnsSorting: _this.props.enableColumnsSorting,
            columnsVisibility: _this.props.columnsVisibility,
            onColumnVisibilityChange: _this.props.onColumnVisibilityChange,
            onClose: _this.toggleColumnsMenu,
            onColumnsOrderChange: _this.props.onColumnsOrderChange,
            columnsOrder: _this.props.columnsOrder
          }));
        }), popperContainer);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "recomputeRowHeights", function () {
        if (_this.list != null) _this.list.recomputeRowHeights();
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getElement", function (index) {
        return _this.getElements().get(index);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getElements", function () {
        return _this.props.elements;
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getTotalCount", function () {
        return _this.getElements().size;
      });

      _this.state = {
        ref: null,
        showColumnsMenu: false,
        scrollbarWidth: 0
      };
      return _this;
    }

    _createClass(PresentationalFunctionalDataGrid, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (this.props.elements !== prevProps.elements) this.recomputeRowHeights();
      }
    }]);

    return PresentationalFunctionalDataGrid;
  }(React__default.PureComponent);

  _defineProperty(PresentationalFunctionalDataGrid, "defaultProps", {
    showGroupHeaders: true,
    includeFilteredElementsInAggregates: false,
    showFooter: true,
    className: '',
    overscanRowCount: 10,
    enableColumnsSorting: false,
    enableColumnsShowAndHide: false,
    onColumnResize: function onColumnResize(e) {},
    onColumnsOrderChange: function onColumnsOrderChange(e) {},
    onColumnVisibilityChange: function onColumnVisibilityChange(e) {},
    onRowClick: function onRowClick(e) {},
    height: '100%'
  });

  var DataGroup = function DataGroup(_key, data, _aggregate) {
    var _this = this;

    _classCallCheck(this, DataGroup);

    _defineProperty(this, "key", void 0);

    _defineProperty(this, "data", void 0);

    _defineProperty(this, "aggregate", void 0);

    _defineProperty(this, "flatten", function (buildHeader) {
      return _this.flatDataGroup(_this, buildHeader);
    });

    _defineProperty(this, "flatDataGroup", function (dataGroup, buildHeader) {
      var elements = dataGroup.data.flatMap(function (el) {
        return el instanceof DataGroup ? _this.flatDataGroup(el, buildHeader) : immutable.List([el]);
      });
      return _this.appendAggregate(_this.prependHeader(dataGroup.key, elements, buildHeader), dataGroup.aggregate);
    });

    _defineProperty(this, "prependHeader", function (key, elements, buildHeader) {
      return buildHeader ? elements.unshift(new DataRow(key, 'group-header', null)) : elements;
    });

    _defineProperty(this, "appendAggregate", function (elements, aggregate) {
      return aggregate == null ? elements : elements.push(new DataRow(aggregate, 'aggregate', null));
    });

    this.key = _key;
    this.data = data;
    this.aggregate = _aggregate;
  };

  var Aggregate = function Aggregate(key, content) {
    _classCallCheck(this, Aggregate);

    _defineProperty(this, "key", void 0);

    _defineProperty(this, "content", void 0);

    this.key = key;
    this.content = content;
  };

  var Engine = function Engine() {
    _classCallCheck(this, Engine);
  };

  _defineProperty(Engine, "computeElements", function (data, groups, sort, filter, columns, showGroupHeaders, includeFilteredElementsInAggregates, aggregatesCalculator, keysMap) {
    return Engine.filterGroups(Engine.groupData(Engine.sortData(Engine.filterData(Engine.enrichData(data, keysMap), filter, groups, includeFilteredElementsInAggregates, columns), sort, columns), groups, immutable.List(), aggregatesCalculator), filter, groups, includeFilteredElementsInAggregates, columns).flatMap(function (e) {
      return Engine.flatGroups(e, showGroupHeaders);
    });
  });

  _defineProperty(Engine, "flatGroups", function (e, showGroupHeaders) {
    return e instanceof DataGroup ? e.flatten(showGroupHeaders) : immutable.List([e]);
  });

  _defineProperty(Engine, "sortData", function (data, sort, columns) {
    return sort.reverse().reduce(function (data, s) {
      return Engine.applySort(data, s, columns);
    }, data);
  });

  _defineProperty(Engine, "applySort", function (data, sort, columns) {
    var column = Engine.getColumnById(Engine.flatColumns(columns), sort.columnId);
    return data.sortBy(function (e) {
      return column.valueGetter(e.content);
    }, function (a, b) {
      return (sort.direction === 'asc' ? 1 : -1) * column.comparator(a, b);
    });
  });

  _defineProperty(Engine, "getColumnById", function (columns, columnId) {
    var column = columns.find(function (c) {
      return c.id === columnId;
    });
    if (column == null) throw new Error('Invalid column id');
    return column;
  });

  _defineProperty(Engine, "getKey", function (e, keysMap) {
    return keysMap.contains(e) != null ? keysMap.get(e) : v4_1();
  });

  _defineProperty(Engine, "enrichData", function (data, keysMap) {
    return data.map(function (e, index) {
      return new DataRow(e, 'element', index, Engine.getKey(e, keysMap));
    });
  });

  _defineProperty(Engine, "groupData", function (data, groups) {
    var currentSubGroup = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : immutable.List();
    var aggregatesCalculator = arguments.length > 3 ? arguments[3] : undefined;
    return groups.isEmpty() ? data : Engine.groupDataByGroup(data, groups.first(), currentSubGroup, aggregatesCalculator).map(function (e) {
      return new DataGroup(e.key, Engine.groupData(e.data, groups.shift(), currentSubGroup.push([groups.first().id, e.key[groups.first().id]]), aggregatesCalculator), e.aggregate);
    });
  });

  _defineProperty(Engine, "groupDataByGroup", function (data, group, subGroup, aggregatesCalculator) {
    return data.groupBy(function (e) {
      return group.groupingFunction(e.content);
    }).map(function (g, key) {
      return Engine.createDataGroup(g, group.id, key, subGroup.push([group.id, key]), aggregatesCalculator);
    }).toList().sort(function (dg1, dg2) {
      return group.comparator(dg1.key, dg2.key, dg1.aggregate, dg2.aggregate);
    });
  });

  _defineProperty(Engine, "createDataGroup", function (data, groupId, key, subGroup, aggregatesCalculator) {
    return aggregatesCalculator != null ? new DataGroup(Engine.getGroupKey(subGroup), data, Engine.createAggregate(Engine.getGroupKey(subGroup), data.map(function (e) {
      return e.content;
    }), aggregatesCalculator)) : new DataGroup(Engine.getGroupKey(subGroup), data);
  });

  _defineProperty(Engine, "createAggregate", function (groupKey, data, aggregatesCalculator) {
    if (aggregatesCalculator == null) throw new Error('Aggregates calculator not specified.');
    return new Aggregate(groupKey, aggregatesCalculator(data.toArray(), groupKey));
  });

  _defineProperty(Engine, "getGroupKey", function (subGroup) {
    var groupKey = {};
    subGroup.forEach(function (g) {
      return groupKey[g[0]] = g[1];
    });
    return groupKey;
  });

  _defineProperty(Engine, "filterElementsBeforeGrouping", function (groups, includeFilteredElementsInAggregates) {
    return groups.isEmpty() || !includeFilteredElementsInAggregates;
  });

  _defineProperty(Engine, "filterData", function (data, filters, groups, includeFilteredElementsInAggregates, columns) {
    return Engine.filterElementsBeforeGrouping(groups, includeFilteredElementsInAggregates) ? data.filter(function (e) {
      return Engine.applyFiltersToElement(e, filters, columns);
    }) : data;
  });

  _defineProperty(Engine, "filterGroups", function (data, filters, groups, includeFilteredElementsInAggregates, columns) {
    return Engine.filterElementsBeforeGrouping(groups, includeFilteredElementsInAggregates) ? data : data.map(function (e) {
      return e instanceof DataGroup ? Engine.filterDataGroup(e, filters, columns) : e;
    }) // filter data group
    .filter(function (e) {
      return !(e instanceof DataGroup) || e.data.size > 0;
    });
  });

  _defineProperty(Engine, "filterDataGroup", function (dataGroup, filters, columns) {
    return new DataGroup(dataGroup.key, dataGroup.data.filter(function (e) {
      return e instanceof DataGroup || Engine.applyFiltersToElement(e, filters, columns);
    }).map(function (e) {
      return e instanceof DataGroup ? Engine.filterDataGroup(e, filters) : e;
    }).filter(function (e) {
      return !(e instanceof DataGroup) || e.data.size > 0;
    }), dataGroup.aggregate);
  });

  _defineProperty(Engine, "applyFiltersToElement", function (e, filters, columns) {
    return filters.reduce(function (a, f) {
      return a && Engine.applyFilterToElement(e, f, columns);
    }, true);
  });

  _defineProperty(Engine, "applyFilterToElement", function (e, filter, columns) {
    return filter.matcher(Engine.getColumnById(columns, filter.columnId).valueGetter(e.content));
  });

  _defineProperty(Engine, "flatColumns", function (columns) {
    return columns.flatMap(function (c) {
      return c instanceof ColumnGroup ? c.columns : [c];
    });
  });

  var debounceTimeout = 250;
  var defaultInitialColumnWidth = 100;
  var defaultRowHeight = 26;

  var FunctionalDataGrid =
  /*#__PURE__*/
  function (_React$PureComponent) {
    _inherits(FunctionalDataGrid, _React$PureComponent);

    function FunctionalDataGrid(props) {
      var _this;

      _classCallCheck(this, FunctionalDataGrid);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(FunctionalDataGrid).call(this, props));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "grid", void 0);

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "debouncedUpdateElements", debounce(function (data, groups, sort, filter, keysMap) {
        return _this.updateElements(data, groups, sort, filter, keysMap);
      }, debounceTimeout));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getData", function () {
        return _this.wrapInImmutableList(_this.props.data);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getColumns", function () {
        return _this.wrapInImmutableList(_this.props.columns);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getColumnGroups", function () {
        return _this.wrapInImmutableList(_this.props.columnGroups);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getInitialSort", function () {
        return _this.wrapInImmutableList(_this.props.initialSort);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getInitialFilter", function () {
        return _this.wrapInImmutableList(_this.props.initialFilter);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getGroups", function () {
        return _this.wrapInImmutableList(_this.props.groups);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "wrapInImmutableList", function (element) {
        return element instanceof immutable.List ? element : immutable.List(element);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentDidUpdate", function (prevProps) {
        if (prevProps.data !== _this.props.data || prevProps.columns !== _this.props.columns) _this.doUpdateElements();
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "doUpdateElements", function () {
        return _this.debouncedUpdateElements(_this.getData(), _this.getGroups(), _this.state.sort, _this.state.filter, _this.state.keysMap);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "render", function () {
        return React__default.createElement(PresentationalFunctionalDataGrid, {
          ref: function ref(_ref) {
            return _this.grid = _ref;
          },
          columns: _this.getColumns(),
          columnGroups: _this.getColumnGroups(),
          elements: _this.state.cachedElements,
          style: _this.props.style,
          showGroupHeaders: _this.props.showGroupHeaders,
          rowHeight: _this.props.rowHeight,
          showFooter: _this.props.showFooter,
          className: _this.props.className,
          overscanRowCount: _this.props.overscanRowCount,
          enableColumnsSorting: _this.props.enableColumnsSorting,
          enableColumnsShowAndHide: _this.props.enableColumnsShowAndHide,
          sort: _this.state.sort,
          groups: _this.getGroups(),
          columnsWidth: _this.state.columnsWidth,
          columnsVisibility: _this.state.columnsVisibility,
          columnsOrder: _this.state.columnsOrder,
          onUpdateSort: _this.updateSortState,
          onUpdateFilter: _this.updateFilterState,
          onColumnResize: _this.resizeColumn,
          onColumnsOrderChange: _this.onColumnsOrderChange,
          onColumnVisibilityChange: _this.updateColumnVisibility,
          onRowClick: _this.props.onRowClick
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getOrderedColumns", function () {
        return _this.state.columnsOrder.map(function (columnId) {
          return _this.getColumns().find(function (c) {
            return c.id === columnId;
          });
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "updateElements", function (data, groups, sort, filter, keysMap) {
        var elements = _this.computeElements(data, groups, sort, filter, keysMap);

        _this.setState({
          cachedElements: elements,
          keysMap: _this.computeKeysMap(elements)
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "computeKeysMap", function (elements) {
        return immutable.Map(elements.filter(function (e) {
          return e.type === 'element';
        }).map(function (e) {
          return [e.content, e.key];
        }));
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "computeElements", function (data, groups, sort, filter, keysMap) {
        return Engine.computeElements(data, groups, sort, filter, _this.getColumns(), _this.props.showGroupHeaders, _this.props.includeFilteredElementsInAggregates, _this.props.aggregatesCalculator, keysMap);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getElement", function (index) {
        return _this.getElements().get(index);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getElements", function () {
        return _this.state.cachedElements;
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "updateSortState", function (columnId, direction) {
        _this.setState({
          'sort': _this.updateSort(_this.state.sort, columnId, direction)
        }, function () {
          _this.doUpdateElements();
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "updateFilterState", function (columnId, matcher) {
        _this.setState({
          'filter': _this.updateFilter(_this.state.filter, columnId, matcher)
        }, function () {
          _this.doUpdateElements();
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "updateFilter", function (filter, columnId, matcher) {
        var index = filter.findIndex(function (c) {
          return c.columnId === columnId;
        });
        return index === -1 ? filter.push(new Filter(columnId, matcher)) : filter.set(index, new Filter(columnId, matcher));
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "updateSort", function (sort, columnId, direction) {
        var index = sort.findIndex(function (c) {
          return c.columnId === columnId;
        });

        if (index === -1) {
          if (direction === 'none') return sort;else return sort.push(new Sort(columnId, direction));
        } else {
          if (direction === 'none') return sort.delete(index);else return sort.set(index, new Sort(columnId, direction));
        }
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "resizeColumn", function (columnId, width) {
        _this.setState({
          columnsWidth: _this.state.columnsWidth.set(columnId, width)
        });

        _this.props.onColumnResize({
          id: columnId,
          width: width
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onColumnsOrderChange", function (columnsOrder) {
        _this.setState({
          columnsOrder: columnsOrder
        });

        _this.props.onColumnsOrderChange({
          columnsOrder: columnsOrder
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getInitialColumnsWidth", function (columns) {
        return columns.groupBy(function (c) {
          return c.id;
        }).map(function (v) {
          return v.get(0).width != null ? v.get(0).width : defaultInitialColumnWidth;
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getInitialColumnsVisibility", function (columns) {
        return columns.groupBy(function (c) {
          return c.id;
        }).map(function (v) {
          return v.get(0).hidden != null ? !v.get(0).hidden : true;
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "updateColumnVisibility", function (columnId, columnVisibility) {
        _this.setState({
          columnsVisibility: _this.state.columnsVisibility.set(columnId, columnVisibility)
        });

        _this.props.onColumnVisibilityChange({
          id: columnId,
          visible: columnVisibility
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "recomputeRowHeights", function () {
        if (_this.grid != null) _this.grid.recomputeRowHeights();
      });

      var _elements = _this.computeElements(_this.getData(), _this.getGroups(), _this.getInitialSort(), _this.getInitialFilter(), immutable.Map());

      var _keysMap = _this.computeKeysMap(_elements);

      _this.state = {
        cachedElements: _elements,
        sort: _this.getInitialSort(),
        filter: _this.getInitialFilter(),
        columnsWidth: _this.getInitialColumnsWidth(_this.getColumns()),
        columnsVisibility: _this.getInitialColumnsVisibility(_this.getColumns()),
        columnsOrder: _this.getColumns().map(function (c) {
          return c.id;
        }),
        keysMap: _keysMap
      };
      return _this;
    }

    return FunctionalDataGrid;
  }(React__default.PureComponent);

  _defineProperty(FunctionalDataGrid, "defaultProps", {
    columnGroups: immutable.List(),
    initialFilter: immutable.List(),
    initialSort: immutable.List(),
    groups: immutable.List(),
    style: {},
    aggregatesCalculator: null,
    showGroupHeaders: true,
    rowHeight: defaultRowHeight,
    includeFilteredElementsInAggregates: false,
    showFooter: true,
    className: '',
    overscanRowCount: 10,
    enableColumnsSorting: false,
    enableColumnsShowAndHide: false,
    onColumnResize: function onColumnResize(e) {},
    onColumnsOrderChange: function onColumnsOrderChange(e) {},
    onColumnVisibilityChange: function onColumnVisibilityChange(e) {},
    onRowClick: function onRowClick(e) {}
  });

  var SelectFilter =
  /*#__PURE__*/
  function (_React$PureComponent) {
    _inherits(SelectFilter, _React$PureComponent);

    function SelectFilter(props) {
      var _this;

      _classCallCheck(this, SelectFilter);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(SelectFilter).call(this, props));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "render", function () {
        return React__default.createElement("select", {
          style: {
            width: '100%',
            boxSizing: 'border-box',
            padding: '2.5px'
          },
          onChange: _this.triggerOnUpdateFilter
        }, React__default.createElement("option", {
          key: -1,
          value: ''
        }), _this.props.choices.map(function (c, index) {
          return React__default.createElement("option", {
            key: index,
            value: c[1]
          }, c[0]);
        }));
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "triggerOnUpdateFilter", function (event) {
        event.persist();

        _this.props.onUpdateFilter(function (value) {
          return event.target.value === '' || value === event.target.value;
        });
      });

      return _this;
    }

    return SelectFilter;
  }(React__default.PureComponent);

  var CheckBoxFilter =
  /*#__PURE__*/
  function (_React$PureComponent) {
    _inherits(CheckBoxFilter, _React$PureComponent);

    function CheckBoxFilter(props) {
      var _this;

      _classCallCheck(this, CheckBoxFilter);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(CheckBoxFilter).call(this, props));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "render", function () {
        return React__default.createElement("input", {
          type: "checkbox",
          checked: _this.state.value,
          onChange: _this.triggerOnUpdateFilter
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "triggerOnUpdateFilter", function (event) {
        event.persist();

        _this.setState({
          value: event.target.checked
        }, function () {
          _this.props.onUpdateFilter(function (value) {
            return value === _this.state.value;
          });
        });
      });

      _this.state = {
        value: null
      };
      return _this;
    }

    return CheckBoxFilter;
  }(React__default.PureComponent);

  var AggregatesCalculators = function AggregatesCalculators() {
    _classCallCheck(this, AggregatesCalculators);
  };

  _defineProperty(AggregatesCalculators, "count", function (elements) {
    return elements.length;
  });

  _defineProperty(AggregatesCalculators, "sum", function (elements) {
    return elements.reduce(function (accumulator, element) {
      return accumulator + element;
    }, 0);
  });

  _defineProperty(AggregatesCalculators, "average", function (elements) {
    return elements.length === 0 ? null : AggregatesCalculators.sum(elements) / elements.length;
  });

  var utils = {
    HeaderColumnResizer: HeaderColumnResizer,
    AggregatesCalculators: AggregatesCalculators
  };
  var filterRenderers = {
    SelectFilter: SelectFilter,
    TextBoxFilter: TextBoxFilter,
    CheckBoxFilter: CheckBoxFilter
  };

  exports.default = FunctionalDataGrid;
  exports.Column = Column;
  exports.BaseColumn = Column;
  exports.ColumnGroup = ColumnGroup;
  exports.Filter = Filter;
  exports.Sort = Sort;
  exports.Group = Group;
  exports.utils = utils;
  exports.filterRenderers = filterRenderers;

  Object.defineProperty(exports, '__esModule', { value: true });

})));



//////////////////
// WEBPACK FOOTER
// ../functional-data-grid/dist/FunctionalDataGrid.umd.js
// module id = 193
// module chunks = 0